import { Label } from "@/components/ui/label";
import { cn } from "@/shared/lib/utils";
import type * as React from "react";
import { useFormContext } from "react-hook-form";

export function useFieldError(name: string): string | undefined {
  const {
    formState: { errors },
  } = useFormContext();
  const error = name
    .split(".")
    // biome-ignore lint/suspicious/noExplicitAny: nested react-hook-form errors
    .reduce<any>((acc, key) => (acc == null ? acc : acc[key]), errors);
  const message = error?.message;
  return typeof message === "string" ? message : undefined;
}

type FieldProps = {
  name: string;
  label?: React.ReactNode;
  hint?: React.ReactNode;
  requiredMark?: boolean;
  className?: string;
  children: React.ReactNode;
};

export function Field({
  name,
  label,
  hint,
  requiredMark,
  className,
  children,
}: FieldProps) {
  const message = useFieldError(name);

  return (
    <div className={cn("space-y-2", className)}>
      {label ? (
        <Label htmlFor={name}>
          {label}
          {requiredMark ? <span className="text-destructive"> *</span> : null}
        </Label>
      ) : null}
      {children}
      {message ? (
        <p className="text-destructive text-sm">{message}</p>
      ) : hint ? (
        <p className="text-muted-foreground text-sm">{hint}</p>
      ) : null}
    </div>
  );
}
